export const ApiConfig = {
  host: process.env.REACT_APP_TABLE_ORDERING_API_HOST || 'http://192.168.1.5',
  baseUrl:
    process.env.REACT_APP_TABLE_ORDERING_API_URL ||
    'http://192.168.1.5/orderart-yii2/api_table_ordering/web'
};
